var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.117,
    height: 5.571,
    viewBox: "0 0 9.117 5.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18022",
    "data-name": "Path 18022",
    d: "M10.194,11.768,13.74,8.222l1.013,1.013-4.558,4.558L5.636,9.235,6.649,8.222Z",
    transform: "translate(-5.636 -8.222)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowSvg);
export default __webpack_public_path__ + "static/media/downArrowSvg.4566d75c633993d8325e98ac06928e75.svg";
export { ForwardRef as ReactComponent };